import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchSalesByDealer = (year, month) => apiActionCreator({
  'endpoint': `/dealers/agencies/sales?year=${year}&month=${month}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SALES_BY_DEALER,
    ActionTypes.FETCHED_SALES_BY_DEALER,
    [
      ActionTypes.FETCHED_SALES_BY_DEALER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchLatestSales = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/dealers/latestSales',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_LATEST_SALES,
        [
          (response) => {
            dispatch(fetchSalesByDealer(response.data.year, response.data.month));
            return {
              'type': ActionTypes.FETCHED_LATEST_SALES,
            };
          },
        ],
        [
          ActionTypes.FETCHED_LATEST_SALES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    }),
  );
};

export const fetchSalesAndBudgets = (initialYear, finalYear) => apiActionCreator({
  'endpoint': `/dealers/sales?initialYear=${initialYear}&finalYear=${finalYear}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SALES_AND_BUDGETS,
    ActionTypes.FETCHED_SALES_AND_BUDGETS,
    [
      ActionTypes.FETCHED_SALES_AND_BUDGETS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearSales = () => ({
  'type': ActionTypes.CLEAR_SALES,
});
